export enum DebtorType {
  Private,
  Business,
  All,
}
